import Type from "@/model/types/Type";

const type = {
    PENDING : 1,
    STARTED : 2,
    FINISHED : 3,
}

const list = [
    {
        value: type.PENDING,
        text: "Pendente",
        buttonVariant: "success",
    },
    {
        value: type.STARTED,
        text: "Em inspeção",
    },
    {
        value: type.FINISHED,
        text: "Inspeciado",
        buttonVariant: "success",
    },
]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}


